// components/ValidationErrorAlert.tsx
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import { Alert, Box, Typography } from "@mui/material";
import { ReactNode } from "react";

interface IValidationAlertItem {
  message: string;
  action?: ReactNode;
}

export const ValidationAlertsStack = ({
  items,
}: {
  items: IValidationAlertItem[];
}) =>
  items
    .filter((i) => i.message)
    .map((item, index) => (
      <Alert
        key={index}
        severity="error"
        action={item.action}
        icon={<ErrorOutline sx={{ color: "error.dark" }} />}
        sx={{
          mt: 2,
          backgroundColor: "error.light",
          border: "1px solid",
          borderColor: "error.dark",
          color: "error.dark",
          borderRadius: 2,
          p: 3,
          display: "flex", 
          alignItems: "center", 
          "& .MuiAlert-icon": { 
            color: "error.dark",
            display: "flex",
            alignItems: "center", 
            py: 0, 
          },
          "& .MuiAlert-message": {
            py: 0,
          }
        }}
      >
        <Typography variant="body1" fontWeight={700} sx={{ fontSize: "16px" }}>
          {item.message}
        </Typography>
      </Alert>
    )) as unknown as JSX.Element;

interface IValidationErrorAlertProps {
  errors: string[] | null | undefined;
  action?: ReactNode;
  sx?: any;
}

export const ValidationAlertWithBullets = ({
  errors,
  action,
  sx,
}: IValidationErrorAlertProps) => {
  if (!errors || errors.length === 0) return null;

  return (
    <Alert 
      severity="warning" 
      sx={{ 
        mt: 2, 
        display: "flex",
        alignItems: "center", 
        "& .MuiAlert-icon": { 
          display: "flex",
          alignItems: "center",
          py: 0 
        },
        "& .MuiAlert-message": { py: 0 },
        ...sx 
      }}
    >
      {errors.length === 1 ? (
        errors[0]
      ) : (
        <ul style={{ margin: 0, paddingLeft: "1rem" }}>
          {errors.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      )}
      {action && <Box sx={{ mt: 1 }}>{action}</Box>}
    </Alert>
  );
};
